import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { isEmpty } from '@ember/utils';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Button from 'umg-ember-backend/components/ui/button/index';
import Form from 'umg-ember-backend/components/ui/form';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

function sortedObjectWithoutKey(callbacks, key) {
  const result = Object.keys(callbacks)
    .sort()
    .reduce((mem, prop) => {
      if (prop !== key) {
        mem[prop] = callbacks[prop];
      }

      return mem;
    }, {});

  return isEmpty(result) ? null : result;
}

export default class RecordDetailFormsAssetTokenConfigComponent extends Component {
  // Getter and setter
  get sortedCallbacks() {
    let callbacks = this.args.model.callbacks;
    return sortedObjectWithoutKey(callbacks, '');
  }

  // Functions
  addCallback = () => {
    let callbacks = this.args.model.callbacks;
    callbacks = sortedObjectWithoutKey(callbacks, '');
    callbacks['Callback ID'] = '';

    this.args.model.callbacks = callbacks;
  };

  removeCallback = (key) => {
    let callbacks = this.args.model.callbacks;
    this.args.model.callbacks = sortedObjectWithoutKey(callbacks, key);
  };

  updateCallback = (key, part, e) => {
    // Update value
    if (part === 'value') {
      this.args.model.callbacks[key] = e.target.value;
      return;
    }

    // Update key
    let callbacks = this.args.model.callbacks;
    let newKey = e.target.value;

    // Rename if newKey.
    if (newKey) {
      callbacks[newKey] = this.args.model.callbacks[key];
    }

    // If newKey is empty the callback is removed by sortedObjectWithoutKey
    this.args.model.callbacks = sortedObjectWithoutKey(callbacks, key);
  };

  addOrigin = () => {
    let origins = this.args.model.origins;
    origins.push('');
    this.args.model.origins = origins;
  };

  removeOrigin = (origin) => {
    const index = this.args.model.origins.indexOf(origin);

    if (index !== -1) {
      this.args.model.origins.splice(index, 1);
    }
  };

  updateOrigin = (origin, e) => {
    const index = this.args.model.origins.indexOf(origin);

    if (index !== -1) {
      this.args.model.origins.splice(index, 1, e.target.value);
    }
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='headline' />

            <fieldset.field @property='origins' @type='string-array' />

            <fieldset.field @property='callbacks'>
              {{#each-in this.sortedCallbacks as |key value|}}
                <div class={{bem 'callback'}}>
                  <input
                    value={{key}}
                    class={{bem 'input' (hash is-de=true)}}
                    aria-label={{t
                      'record_detail.forms.asset_token_config.edit_callback_key'
                    }}
                    {{on 'change' (fn this.updateCallback key 'key')}}
                  />
                  <input
                    value={{value}}
                    class={{bem 'input' (hash is-de=true)}}
                    aria-label={{t
                      'record_detail.forms.asset_token_config.edit_callback_value'
                    }}
                    {{on 'change' (fn this.updateCallback key 'value')}}
                  />
                  <Button
                    @style='outline'
                    @icon='delete'
                    @iconClass='u-color-error'
                    class={{bem 'remove'}}
                    aria-label={{t
                      'record_detail.forms.asset_token_config.remove_callback'
                    }}
                    {{on 'click' (fn this.removeCallback key)}}
                  />
                </div>
              {{/each-in}}

              <Button
                @label={{t
                  'record_detail.forms.asset_token_config.add_callback'
                }}
                @icon='add'
                @style='outline'
                {{on 'click' this.addCallback}}
              />
            </fieldset.field>
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='assets'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>
          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
